import { graphql } from "react-relay";

export const fragments = {
  payload: graphql`
    fragment SuggestionActionReschedule_payload on SuggestionActionReschedulePayload {
      calendarId
      externalEventId
      betterTime {
        date
        timeSlot
      }
      nearestAlternateTime {
        date
        timeSlot
      }
      eventStartWeek
      event {
        calendarIds
        isAllDay
        eventKey {
          externalEventId
        }
        startTime {
          millis
          dateOrDateTime
          timeZone
        }
        endTime {
          millis
        }
        title
        attendees {
          displayName
          urnValue
        }
        organizer {
          urnValue
        }
      }
    }
  `,
};
